import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { HeroSection } from "./components/sections/HeroSection";
import { SpecialOfferBanner } from "./components/sections/SpecialOfferBanner";
import { SystemIntroSection } from "./components/sections/SystemIntroSection";
import { StorySection } from "./components/sections/StorySection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { PainPointsSection } from "./components/sections/PainPointsSection";
import { ReframeSection } from "./components/sections/ReframeSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { CollectionSection } from "./components/sections/CollectionSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { DifferenceSection } from "./components/sections/DifferenceSection";
import { AuthorNoteSection } from "./components/sections/AuthorNoteSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection } from "./components/sections/FinalCtaSection";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="2zn6biws0edn8">
      <MetaPixel data-id="element-1" data-mp="33mykhalbelt4" />
      <HeroSection data-id="element-2" data-mp="33oi1j3esp0vy" />
      <main data-id="element-3" data-mp="38m1fe27kzbnd">
        <SpecialOfferBanner data-id="element-4" data-mp="38li95irambp6" />
        <SystemIntroSection data-id="element-5" data-mp="38k6ugnwb7jja" />
        <StorySection data-id="element-6" data-mp="38o4gpie6or7e" />
        <BeforeAfterSection data-id="element-7" data-mp="3dkl0k0ecojeo" />
        <PainPointsSection data-id="element-8" data-mp="3dlw9sfqkejd6" />
        <ReframeSection data-id="element-9" data-mp="3dm5vvs8ho6dl" />
        <VolumesSection data-id="element-10" data-mp="nvj3jfxq0epq" />
        <CollectionSection data-id="element-11" data-mp="nwc2vvuco1xu" />
        <BonusesSection data-id="element-12" data-mp="nv0ypuwzss67" />
        <TestimonialsSection data-id="element-13" data-mp="nxwxflgnzkvp" />
        <OfferSection data-id="element-14" data-mp="su44xiopl4fr" />
        <GuaranteeSection data-id="element-15" data-mp="stkok6epio3u" />
        <DifferenceSection data-id="element-16" data-mp="ssss6tdacmci" />
        <AuthorNoteSection data-id="element-17" data-mp="36hw15qrsq0p" />
        <FaqSection data-id="element-18" data-mp="35oxut5vn8u6" />
        <FinalCtaSection data-id="element-19" data-mp="356wxj89s6fx" />
      </main>
      <footer className="bg-ink px-4 pb-28 pt-10 text-center text-white/75" data-id="element-20" data-mp="38b2ol1dva8p">
        <p className="font-serif text-xl font-bold text-white" data-id="element-21" data-mp="3ucj91juaptoz">Menopause Decision Map™</p>
        <p className="mt-1 text-sm" data-id="element-22" data-mp="d45v27vesjoo">Created by Dr. Karito</p>
        <p className="mx-auto mt-5 max-w-2xl text-xs leading-relaxed" data-id="element-23" data-mp="85bbh3pmar3i">
          Educational resources for healthcare professionals. This material does not replace individualized clinical
          judgment, comprehensive patient assessment, current professional guidelines, or applicable local regulations.
        </p>
        <p className="mt-4 text-xs" data-id="element-24" data-mp="3qbzgktko3e96">© 2026 Dr. Karito — Menopause Decision Map™. All rights reserved.</p>
      </footer>
      <FloatingCta anchorId="hero-cta" data-id="element-25" data-mp="3lj6aa19jvxuz" />
      <PurchasePopup data-id="element-26" data-mp="2xun4bsdz3x62" />
    </div>;
}